import React, { memo, useCallback } from 'react';
import { Chip } from '@landr/maestro';
import { FiltersParams } from 'types/params';
import { useApiFiltersContext } from 'contexts/ApiFiltersContext/ApiFiltersContext';
import { css } from '@landr/styled-system/css';

type ActiveFilterProps = {
    filter: string;
    queryKey?: FiltersParams;
    onClick: () => void;
};

const ActiveFilter = memo(
    ({ filter, queryKey, onClick }: ActiveFilterProps) => {
        const { getFilterLabel } = useApiFiltersContext();

        const handleOnClick = useCallback(() => onClick(), [onClick]);

        const label = queryKey ? getFilterLabel(filter, queryKey) : filter;

        return (
            <Chip
                onClick={handleOnClick}
                onDismiss={handleOnClick}
                size="sm"
                palette="subtle"
                backgroundColor="surface.inverted"
                color="text.inverted"
                className={css({
                    '& svg': {
                        color: 'icon.inverted',
                    },
                })}
                textTransform="lowercase"
            >
                {label}
            </Chip>
        );
    },
);

export default ActiveFilter;
